











import { Component, Vue } from "vue-property-decorator";
import _ from "lodash";

import { QuestionnaireLookups, QuestionnaireModel, CriticalSkillModel } from "@/core/models";
import { QuestionnaireService } from "@/core/services";
import { QuestionnaireFormCpt } from "./components";
import AppVue from "@/AppVue.vue";

@Component({
  components: {
    QuestionnaireFormCpt,
  },
  beforeRouteLeave(to, from, next) {
    if ((this.$refs.qnr as any).hasUnsavedChanges === false) {
      next();
      return;
    }

    if (
      confirm(
        "You have unsaved changes in your questionnaire (to save, please press the save button at the bottom of the page). Are you sure you want to navigate away from this page and lose any unsaved changes?",
      )
    ) {
      next();
    }
  },
})
export default class QuestionnaireFormView extends AppVue {
  lookups = new QuestionnaireLookups();
  model = new QuestionnaireModel();
  loading = false;
  loadingLookups = false;

  get questionnaireId() {
    return this.$route.params.questionnaireId as any;
  }

  async created() {
    this.$eventHub.$on("REFRESH_QNR_MODEL", () => {
      this.initializeModel();
    });

    this.$eventHub.$on("MATCH_SKILL_ADDED", async (result: any, skill: CriticalSkillModel) => {
      await this.initializeLookups();
      skill.skillMatchId = result.id;
    });

    await this.initializeLookups();
    await this.initializeModel();
  }

  destroyed() {
    // NOTE: This maybe needs to be async/await
    this.undoCheckOut();
  }

  private async undoCheckOut() {
    if (this.isImi || this.isUser) {
      try {
        this.loading = true;
        await QuestionnaireService.undoCheckOut(this.model.id);
      } finally {
        this.loading = false;
      }
    }
  }

  private async initializeLookups() {
    this.loadingLookups = true;
    try {
      const lookups = await QuestionnaireService.getQuestionnaireLookups();

      _.extend(this.lookups, lookups);
    } finally {
      this.loadingLookups = false;
    }
  }

  private async initializeModel() {
    this.loading = true;
    try {
      const model = this.questionnaireId
        ? await QuestionnaireService.getQuestionnaireById(this.questionnaireId)
        : await QuestionnaireService.getQuestionnaire();

      _.extend(this.model, model);
      (this.$refs.qnr as any).checkLastStep();
      (this.$refs.qnr as any).setHasUnsavedChanges(false);
    } finally {
      this.loading = false;
    }
  }
}
